import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Progress from "../../../../ui/Progress";
import TopBar from "./TopBar";
import Box from "../../../../ui/Box";
import StudyRequestDrawer from "../../components/StudyRequestDrawer";
import StudyRequestInfo from "./StudyRequestInfo";
import RequestWorkSteps from "./RequestWorkSteps";
import DeleteConfirmationModal from "../../../../ui/DeleteConfirmationModal";
import AcceptRequestModal from "./AcceptRequestModal";
import DeclineRequestModal from "./DeclineRequestModal";
import {getRequestSystemInfo, getRequestMainInfo, getRequestCard} from "../../store/actions";
import {sendRequestToWork, sendRequestToApprove, sendRequestToDecline, sendRequestToArchive} from "../../store/send";
import {deleteRequest} from "../../store/deleteactions";
import {useMediaQuery} from 'react-responsive';
import Tabs from "../../../../ui/Tabs";
import Programs from "./Programs";
import StudentRelation from "./StudentRelation";
import Alert from "@material-ui/lab/Alert";
import Dialog from "./Dialog";
import Documents from "./Documents";

const useStyles = makeStyles(() => ({
    viewRoot: {
      display: "flex",
    },
    pageRoot: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1
    },
    topBar: {
      marginBottom: 10
    },
    root: {
      //maxWidth: 774,
      minWidth: 400,
      paddingLeft: 8,
      "& .MuiFormLabel-root": {
        whiteSpace: "nowrap"
      },
      "& .MuiInputBase-input.Mui-disabled": {
        color: "#000"
      }
    },
    heading: {
      fontSize: 14,
      lineHeight: "18px",
      display: "flex",
      alignItems: "center",
      color: "#000000",
      margin: "8px 0"
    },
  caption: {
    color: "#778899",
    fontSize: 10,
    marginBottom: 16
  }
})
);

const items = [
  {
      label: "Управление записью на обучение",
      link: "/work/app/study"
  },
  {
      label: "Заявки на обучение",
      link: "/work/app/study/request"
  }
];

const tabitems = [
  {number: 0, caption: "Общие сведения"},
  {number: 1, caption: "Обучающийся"},
  {number: 2, caption: "Программа обучения"},
  {number: 3, caption: "История рассмотрения"},
  {number: 4, caption: "Сообщения"},
  {number: 5, caption: "Документы"}
];

const StudyRequestView = ({ match,
                            history,
                            getRequestSystemInfo,
                            metaInfo,
                            getRequestMainInfo,
                            requestMain,
                            sendRequestToWork,
                            sendRequestToApprove,
                            sendRequestToDecline,
                            sendRequestToArchive,
                            isFetchingWorkProcess,
                            workProcess,
                            getRequestCard,
                            deleteRequest
                          }) => {
  const { id } = match.params;
  const classes = useStyles();

  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [acceptModalOpen, setAcceptModalOpen] = React.useState(false);
  const [declineModalOpen, setDeclineModalOpen] = React.useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = React.useState(false);

  //const [isEditable, setEditable] = React.useState(false);

  const returnBack = () => {
    history.push("/work/app/study/request");
  }

  const reloadRequest = () => {
    getRequestSystemInfo(id);
    getRequestMainInfo(id);
    getRequestCard(id);
  }

  const sendToWork = () => {
    sendRequestToWork(id);
  }

  const sendToArchive = () => {
    sendRequestToArchive(id);
  }

  const deleteRequestProgram = () => {
    deleteRequest(id);
    returnBack();
  }

  useEffect(() => {
    getRequestSystemInfo(id);
    getRequestMainInfo(id);
  }, [id]);

  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});
  return (
    <div>
      <Breadcrumbs items={items} />
      {requestMain ? (
        <div className={classes.viewRoot}>
          <DeleteConfirmationModal
            modalText="Вы уверены, что хотите удалить заявку на обучение?"
            open={deleteModalOpen}
            onConfirm={deleteRequestProgram}
            handleClose={() => setDeleteModalOpen(false)}
            buttonCaption="УДАЛИТЬ"
          />
          <DeleteConfirmationModal
            modalText="Отправить заявку в архив?"
            open={archiveModalOpen}
            onConfirm={sendToArchive}
            handleClose={() => setArchiveModalOpen(false)}
            buttonCaption="ПОДТВЕРДИТЬ"
          />
          {requestMain.status == 1 && <>
          <DeclineRequestModal
            requestData={requestMain}
            requestCount={1}
            open={declineModalOpen}
            handleClose={() => setDeclineModalOpen(false)}
            handleDecline={sendRequestToDecline}
            isDecliningRequest={isFetchingWorkProcess}
            //declinedRequest={declinedRequest}
          />

            {requestMain.group && requestMain.person &&
            <AcceptRequestModal
              requestData={requestMain}
              open={acceptModalOpen}
              handleClose={() => setAcceptModalOpen(false)}
              handleAccept={sendRequestToApprove}
              isAcceptingRequest={isFetchingWorkProcess}
              //acceptedRequest={acceptedRequest}
            />}
            </>}
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                statusId={requestMain.status || 0}
                returnBack={returnBack}
                reload={reloadRequest}
                isAcceptingRequest={isFetchingWorkProcess}
                isDecliningRequest={isFetchingWorkProcess}
                isArchivingRequest={isFetchingWorkProcess}
                openDeleteModal={() => setDeleteModalOpen(true)}
                openAcceptModal={() => setAcceptModalOpen(true)}
                openDeclineModal={() => setDeclineModalOpen(true)}
                openArchiveModal={() => setArchiveModalOpen(true)}
                sendToWork = {sendToWork}
                isSendingToWork = {isFetchingWorkProcess}
                disabledApprove={isFetchingWorkProcess ||
                                requestMain.program === null ||
                                requestMain.group === null}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                {(requestMain.programId === null ||
                requestMain.group === null ||
                requestMain.relatedStudent === null) &&
                <Alert style={{marginBottom: "16px"}} severity="warning">
                  {requestMain.programId === null && <div>Нет связи заявки с программой обучения.</div>}
                  {requestMain.group === null && <div>Не выбрана учебная группа.</div>}
                </Alert>
                }
                <StudyRequestInfo requestId={id}/>
              </Box>
              <Box noMargin>
                <StudentRelation requestId={id}
                                 targetAudience={requestMain.targetAudience}
                                 relatedStudent={requestMain.relatedStudent}
                                 schoolchild={requestMain.schoolchild}
                                 schoolchildParent={requestMain.schoolchildParent}
                                 studentSnils={requestMain.studentSnils}
                                 student={requestMain.student}
                                 person={requestMain.person}
                                 status={requestMain.status}/>
              </Box>
              <Box noMargin>
                <Programs requestId={id}
                          status={requestMain.status}
                          programId={requestMain.programId}
                          requestProgramName={requestMain.myProgram ? requestMain.myProgram.name : ''}
                          requestProgramTargetGroup={requestMain.myProgram ? requestMain.myProgram.targetGroup : ''}
                          isFetchingWorkProcess={isFetchingWorkProcess}/>
              </Box>
              <Box noMargin>
                <RequestWorkSteps requestId={id}/>
              </Box>
              <Box noMargin>
                <Dialog requestId={id}/>
              </Box>
              <Box noMargin>
                <Documents requestId={id}/>
              </Box>
            </Tabs>
          </div>
          {isLarge &&
          <StudyRequestDrawer requestId={id} open hideLink />}
        </div>
      ) : (
        <Progress />
      )}
    </div>
  )}

const mapStateToProps = state => ({
  metaInfo: state.studyRequests.metaInfo,
  requestMain: state.studyRequests.requestMain,
  isFetchingWorkProcess: state.studyRequests.isFetchingWorkProcess,
  workProcess: state.studyRequests.workProcess,
  isDeletingRequestProgram: state.studyRequests.isDeletingRequestProgram
});

const mapDispatchToProps = dispatch => ({
  getRequestSystemInfo: (id) => dispatch(getRequestSystemInfo(id)),
  getRequestMainInfo: (id) => dispatch(getRequestMainInfo(id)),
  getRequestCard: (id) => dispatch(getRequestCard(id)),
  sendRequestToWork: (id) => dispatch(sendRequestToWork(id)),
  sendRequestToApprove: (id, comment) => dispatch(sendRequestToApprove(id, comment)),
  sendRequestToDecline: (id, comment) => dispatch(sendRequestToDecline(id, comment)),
  sendRequestToArchive: (id) => dispatch(sendRequestToArchive(id)),
  deleteRequest: (id) => dispatch(deleteRequest(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StudyRequestView));
